<script setup>
defineProps({
  countries: {
    type: Array,
    default: () => [],
  },

  modelValue: {
    type: Number,
    default: undefined,
  },
});
const emit = defineEmits(['update:modelValue']);
</script>

<template>
  <div class="bundles-trains-navigation-columns-countries">
    <button
      v-for="(country, index) in countries"
      :key="index"
      type="button"
      class="bundles-trains-navigation-columns-countries__country"
      :class="{
        'bundles-trains-navigation-columns-countries__country--active':
          modelValue === country.id,
      }"
      @click="emit('update:modelValue', country.id)"
    >
      <CCountryFlag
        v-if="country.countryId"
        class="bundles-trains-navigation-columns-countries__flag"
        :code="country.countryId"
      />

      <span class="bundles-trains-navigation-columns-countries__font">
        {{ country.title }}
      </span>

      <CIcon
        v-if="modelValue === country.id"
        class="bundles-trains-navigation-columns-countries__icon"
        name="chevron-right"
      />
    </button>
  </div>
</template>

<style scoped lang="scss">
.bundles-trains-navigation-columns-countries {
  $parent: &;

  display: flex;
  flex-direction: column;
  padding: em(18) em(40) em(20);
  overflow: hidden auto;
  background-color: $color-gray-10;
  border-radius: em(8);

  &__font {
    font-size: em(24);
  }

  &__icon {
    @include box(em(16));

    flex-shrink: 0;
    margin-left: auto;
    color: $color-black;
  }

  &__country {
    display: flex;
    flex-shrink: 0;
    gap: em(20);
    align-items: center;
    padding: em(17) 0 em(18);
    color: $color-main-5;
    transition: color $time-3;

    &:not(:last-child) {
      border-bottom: 1px solid rgba($color-black, 0.1);
    }

    @include hover {
      color: $color-second-1;
    }

    &--active {
      color: $color-second-1;

      #{$parent} {
        &__font {
          font-weight: 600;
        }
      }
    }
  }
}
</style>
